// The three licence tiers a tenant can have. The backend (azure-function/src/lib/license.js) decides
// what each tier allows and sends the answer as `tenant.license`; this file only holds the wording
// and what to show for each tier, so the tenant list, the edit panel and the lock screens agree.

export const SALES_EMAIL = 'support@nordcomply.dk';

export const TIERS = [
  {
    key: 'trial',
    label: 'Trial',
    short: '30 dage, begrænset',
    includes: ['Alle sider er åbne i 30 dage'],
    limits: [
      'Rapporter får vandmærket "Trial"',
      'Ingen automatiske rapportmails',
      'Ingen eksport af rå data',
      'Datasynk højst én gang i døgnet',
      'Én prøveperiode pr. Microsoft-tenant, kan ikke genstartes',
    ],
  },
  {
    key: 'standard',
    label: 'Standard',
    short: 'Overblik og Gennemgang',
    includes: ['Overblik og samlet score', 'Gennemgang af fund', 'Konfiguration og Compliance', 'Historik og IT-opgaver', 'Datakilder'],
    missing: ['Beslutninger', 'Rapporter'],
  },
  {
    key: 'premium',
    label: 'Premium',
    short: 'Plus dokumentation',
    includes: ['Alt i Standard', 'Beslutninger', 'Rapporter, også automatisk udsendelse', 'Eget logo på rapporter'],
  },
];

export function tierLabel(key) {
  return TIERS.find((t) => t.key === key)?.label || key || '';
}

// What each locked page offers, shown on the Premium lock screen.
export const PREMIUM_PAGES = {
  decisions: {
    title: 'Beslutninger',
    points: [
      'Dokumentér hvorfor et fund accepteres eller udskydes',
      'Med ansvarlig, dato og begrundelse',
      'Indgår automatisk i revisionsrapporten',
    ],
  },
  audit: {
    title: 'Rapporter',
    points: [
      'Revisionsklare PDF-rapporter til ISO 27001, NIS2, GDPR og CIS',
      'Sendes automatisk til ledelse og revisor',
      'Med jeres eget logo',
    ],
  },
  history: {
    title: 'Historik',
    points: [
      'Se sikkerhedsniveauet udvikle sig over tid',
      'Dokumentér hvornår et fund blev lukket',
      'Bevis til revisor',
    ],
  },
};

export function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', year: 'numeric' });
}

// "Trial · 18 dage tilbage", "Premium" — the licence as one short line.
export function licenseSummary(license) {
  if (!license) return '';
  if (license.tier === 'trial') {
    if (license.expired) return 'Trial udløbet';
    return `Trial · ${license.daysLeft} ${license.daysLeft === 1 ? 'dag' : 'dage'} tilbage`;
  }
  return tierLabel(license.tier);
}

export function tenantLicense(tenant) {
  return licenseSummary(tenant?.license);
}
